var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 195,
    viewBox: "0 0 424 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0438 8.72C41.0438 4.45637 47.167 1 54.7203 1L369.28 1C376.833 1 382.956 4.45636 382.956 8.72V29.3025C406.839 42.6117 423 68.1639 423 97.5C423 126.836 406.839 152.388 382.956 165.697V186.28C382.956 190.544 376.833 194 369.28 194L54.7203 194C47.167 194 41.0438 190.544 41.0438 186.28V165.697C17.1606 152.388 1 126.836 1 97.5C1 68.1639 17.1606 42.6117 41.0438 29.3025V8.72Z",
    fill: "#181818",
    fillOpacity: 0.5,
    stroke: "#EE7B07",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxBg);
export default __webpack_public_path__ + "static/media/tax-bg.86c83f824280c6543a1589d6080d71e1.svg";
export { ForwardRef as ReactComponent };